import { ErrorHandler, Injectable } from "@angular/core";
import * as Sentry from "@sentry/browser";
import { environment } from "../../../environments/environment";

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor() {}

  handleError(error: Error) {
    const chunkFailedMessage = /Loading chunk [\d]+ failed/;
    if(!environment.production) console.log('error ==>',error);
    if (chunkFailedMessage.test(error.message)) {
      window.location.reload();
    } else {
      const errorsArray = [
        "Unexpected end of JSON input",
        "getClientRect",
        "clientRect",
        "Username and Pool information are required",
        "graph.instagram.com",
        "Non-Error exception captured with keys",
        "Http failure response for",
        "_reportEvent",
        "nativeElement",
        "https://api.sitecreator.io/v1/getSiteByRoute",
        "animation",
        "saveNewImage",
        "postAnalytics",
        "InvalidAccessError",
        "getSiteByRoute",
        "during parsing",
        "LatLng",
        "NaN, NaN",
        "not allowed by the user agent",
        "NotAllowedError",
        "UnhandledRejection",
        "promise rejection captured",
        "ResizeObserver"
      ];
      let exist = false;
      errorsArray.forEach((err) => {
        if (!exist) {
          exist = error.message.includes(err);
        }
      });
      if (!exist) {
        // if (!environment.production) console.error('error ==>',error);
        Sentry.configureScope(function (scope) {
          scope.setExtra("error_page_url", location.hostname);
          scope.setExtra("error_message", error.message);
        });

        Sentry.captureException(error.message);
      }
    }
  }
}
